import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dashboard, EstadisticasModel } from '../models/dashboard.interface';

@Injectable()
export class DashboardService {
  public codEstablecimiento: number;

  constructor(private http: HttpClient) {}

  public getEstadisticas(data: EstadisticasModel) {
    return this.http.post<Dashboard>(
      `${environment.API_URL}/Estadisticas/`,
      data
    );
  }
}
